import Loading from "@@/core/components/shared/Loading/Loading";
import ActionModal from "@@/core/components/action/ActionForm/ActionForm";
import { BTooltip, BTable } from "bootstrap-vue";
import mixins from "@@/core/mixins/mixins";

const createEmptyAction = () => ({
  id: null,
  title: "",
  level_id: null,
  type: "free_shipping",
  type_value: 0,
  start_date: "",
  end_date: "",
  index: null,
});

export default {
  name: "Action",

  components: {
    Loading,
    ActionModal,
    BTooltip,
    BTable,
  },

  mixins: [mixins],

  data() {
    return {
      url: "admin/actions",
      submit_url: "admin/actions",
      levelsUrl: "admin/levels?show_all=1",
      levels: [],
      levelsLoading: false,
      mode: "create",
      action: createEmptyAction(),
      fields: [
        { key: "id", label: "شناسه" },
        { key: "title", label: "عنوان" },
        { key: "level", label: "سطح" },
        { key: "type", label: "نوع عملیات" },
        { key: "type_value", label: "مقدار" },
        { key: "start_date", label: "تاریخ شروع" },
        { key: "end_date", label: "تاریخ پایان" },
        { key: "created_at", label: "تاریخ ثبت" },
        { key: "show", label: "مشاهده" },
        { key: "delete", label: "حذف" },
      ],
    };
  },

  computed: {
    tableItems() {
      return this.items && Array.isArray(this.items.data)
        ? this.items.data
        : [];
    },

    hasRows() {
      return this.tableItems.length > 0;
    },
  },

  mounted() {
    this.loadItems();
    this.loadLevels();
  },

  methods: {
    async loadLevels() {
      this.levelsLoading = true;
      try {
        const response = await this.$axios.get(this.levelsUrl);
        this.levels = response && response.data.data.levels ? response.data.data.levels : {};
      } catch (error) {
        this.levels = [];
        this.$root.notify(error);
      } finally {
        this.levelsLoading = false;
      }
    },

    newAction() {
      if (this.disabled || !this.hasPermission("write_customer")) {
        return;
      }

      this.mode = "create";
      this.submit_url = this.url;
      this.action = createEmptyAction();

      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "action-modal");
      });
    },

    editItem(id, index) {
      if (this.disabled || !this.hasPermission("modify_customer")) {
        return;
      }

      const source = this.tableItems.find((item) => item.id == id);

      if (!source) {
        this.$root.notify("عملیات موردنظر پیدا نشد.");
        return;
      }

      this.mode = "edit";
      this.submit_url = `${this.url}/${id}`;
      this.action = {
        ...createEmptyAction(),
        ...source,
        level_id:
          source.level_id ||
          (source.level && source.level.id ? source.level.id : null),
        type_value:
          source.type === "wallet_charge"
            ? source.type_value
            : 0,
        index,
      };

      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "action-modal");
      });
    },

    handleSaved(savedAction, mode, index) {
      if (!savedAction) {
        this.loadItems();
        return;
      }

      if (!this.items || !Array.isArray(this.items.data)) {
        this.loadItems();
        return;
      }

      if (mode === "edit") {
        let targetIndex = Number.isInteger(index) ? index : -1;

        if (targetIndex < 0) {
          targetIndex = this.items.data.findIndex(
            (item) => item.id == savedAction.id
          );
        }

        if (targetIndex >= 0) {
          this.$root.$set(this.items.data, targetIndex, savedAction);
        } else {
          this.loadItems();
        }

        return;
      }

      this.items.data.unshift(savedAction);

      if (typeof this.items.total === "number") {
        this.items.total += 1;
      }
    },

    getLevelTitle(item) {
      if (!item) {
        return "-";
      }

      if (item.level_title) {
        return item.level_title;
      }

      if (item.level) {
        return (
          item.level.title ||
          item.level.name ||
          item.level.label ||
          item.level.display_name ||
          `سطح ${item.level.id}`
        );
      }

      const level = this.levels.find((row) => row.id == item.level_id);
      return level ? level.title : item.level_id || "-";
    },

    getTypeLabel(type) {
      const labels = {
        free_shipping: "ارسال رایگان",
        wallet_charge: "شارژ کیف پول",
      };

      return labels[type] || type || "-";
    },

    formatTypeValue(item) {
      if (!item || item.type === "free_shipping") {
        return "-";
      }

      if (
        item.type_value === null ||
        typeof item.type_value === "undefined" ||
        item.type_value === ""
      ) {
        return "-";
      }

      const numericValue = Number(item.type_value);

      if (Number.isNaN(numericValue)) {
        return item.type_value;
      }

      return new Intl.NumberFormat("fa-IR").format(numericValue);
    },
  },
};
